var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1218_5046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8919 0H4.10814C1.84282 0 0 1.84282 0 4.10814V21.8919C0 24.1572 1.84282 26 4.10814 26H21.8919C24.1572 26 26 24.1572 26 21.8919V4.10814C26 1.84282 24.1572 0 21.8919 0ZM23.2612 21.8919C23.2612 22.6469 22.6469 23.2612 21.8919 23.2612H4.10814C3.35313 23.2612 2.73888 22.6469 2.73888 21.8919V4.10814C2.73888 3.35313 3.35321 2.73888 4.10814 2.73888H21.8919C22.6469 2.73888 23.2611 3.35321 23.2611 4.10814V21.8919H23.2612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0444 7.69781C17.6027 7.69781 17.1876 7.86992 16.8752 8.18243L10.7566 14.311L9.12579 12.6804C8.81358 12.3681 8.39844 12.196 7.95688 12.196C7.51524 12.196 7.10011 12.3681 6.78782 12.6803C6.4756 12.9925 6.30371 13.4076 6.30371 13.8492C6.30371 14.2908 6.4756 14.7059 6.78782 15.018L9.58787 17.8181C9.90009 18.1304 10.3152 18.3024 10.7569 18.3024C11.1983 18.3024 11.6136 18.1303 11.9261 17.8178L19.2134 10.52C19.8579 9.87539 19.8578 8.82658 19.2134 8.18192C18.9012 7.86978 18.486 7.69781 18.0444 7.69781Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1218_5046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.f75ba4fb763742971220fd901d2380f6.svg";
export { ForwardRef as ReactComponent };